// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container_3d0Ap","tooltip":"Info_tooltip_WHmUb"};